import { Droplets, Activity, Zap, TrendingDown } from 'lucide-react';
import { type BodySignal } from '@/hooks/useDashboardData';

interface BodySignalsGridProps {
  hydration: BodySignal;
  bowel: BodySignal;
  energy: BodySignal;
  bloating: BodySignal;
}

interface SignalCardProps {
  icon: any;
  label: string;
  signal: BodySignal;
  color: string;
  bg: string;
}

const SignalCard = ({ icon: Icon, label, signal, color, bg }: SignalCardProps) => (
  <div className="bg-card rounded-2xl p-4 shadow-card">
    <div className={`w-8 h-8 ${bg} rounded-xl flex items-center justify-center mb-2`}>
      <Icon className={`h-4 w-4 ${color}`} />
    </div>
    <p className="text-xs text-muted-foreground">{label}</p>
    <p className="text-sm font-semibold mt-0.5">{signal.value}</p>
    {signal.trend && (
      <p className="text-[11px] text-primary font-medium mt-1">{signal.trend}</p>
    )}
    {signal.interpretation && (
      <p className="text-[11px] text-muted-foreground mt-0.5 leading-snug">{signal.interpretation}</p>
    )}
  </div>
);

const BodySignalsGrid = ({ hydration, bowel, energy, bloating }: BodySignalsGridProps) => {
  return (
    <div>
      <h2 className="text-sm font-medium mb-3">Señales de tu cuerpo</h2>
      <div className="grid grid-cols-2 gap-3">
        <SignalCard
          icon={Droplets}
          label="Hidratación"
          signal={hydration}
          color="text-wellness-blue"
          bg="bg-wellness-blue-light"
        />
        <SignalCard
          icon={Activity}
          label="Intestino"
          signal={bowel}
          color="text-primary"
          bg="bg-secondary"
        />
        <SignalCard
          icon={Zap}
          label="Energía"
          signal={energy}
          color="text-wellness-peach"
          bg="bg-wellness-peach-light"
        />
        <SignalCard
          icon={TrendingDown}
          label="Hinchazón"
          signal={bloating}
          color="text-wellness-purple"
          bg="bg-wellness-purple-light"
        />
      </div>
    </div>
  );
};

export default BodySignalsGrid;
